// extracted by mini-css-extract-plugin
module.exports = {"DesignerListPage":"styles_DesignerListPage__3rLTY","filterAlphabet":"styles_filterAlphabet__HTSYT","stickyNav":"styles_stickyNav__0YAh7"};